import { FormatedField } from "../types/fields.types";

type CustomizedField = {
    name: string;
    entity: string;
};

export const isCustomizedField = (field: FormatedField) => {
    const customizedFields = [
        { name: "treatment_provided", entity: "treatments" },
        { name: "client_treatment_provided", entity: "clients" },
        { name: "birthday", entity: "clients" },
        { name: "birthday", entity: "leads" },
        { name: "birthday", entity: "candidates" },
        { name: "comments", entity: "tasks" },
        { name: "title", entity: "feedbacks" },
        { name: "user_created", entity: "*" },
        { name: "user_updated", entity: "*" },
        { name: "amount", entity: "bank_transactions" },
        { name: "content", entity: "templates_content" },
        { name: "neurofeedback_goal", entity: "protocols" },
        { name: "treatment_prescription", entity: "treatments" },
        { name: "operations_staff_agreement_id", entity: "staff_remuneration" },
        { name: "orders_payments", entity: "orders" },
        { name: "content_evaluation", entity: "evaluations"}
    ];

    const containsField = (customizedFields: Array<CustomizedField>, field: FormatedField) => {
        return customizedFields.some((customizedField) => {
            const isUserField = (customizedField.name === "user_created" || customizedField.name === "user_updated") && 
                                customizedField.name === field.field;
            if (isUserField) {
                return true;
            }

            return customizedField.name === field.field && customizedField.entity === field.settings.entity;
        });
    };

    return containsField(customizedFields, field);
};
